import { useMutation, UseMutationResult } from 'react-query';
import { Like } from '../../models/Like';
import { like } from '../../services/likes/likes.service';

export default (): UseMutationResult<Like, void, string, void> => {
  return useMutation((articleId: string) => like(articleId));
};
